export default {
  title: {
    en: 'Cancel Skip',
  },
}
